import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const Fields = [
    { label: 'Name', name: 'description', type: 'text', required: true},
    { label: 'Address', name: 'address', type: 'text', required: true},
    
    {
        name: "location",
        label: "Location",
        type: "mapinput",
        required: true,
    },
];

const NewGarage = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const handleAddGarage = async (formData) => {
        try {
            const response = await ApiManager.addGarage(formData);
            return response;
        } catch (error) {
            console.error('Error creating garage:', error);
            throw error;
        }
    };

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
            <button className="custom-button" onClick={toggleModal}>
                New Garage
            </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add Garage"
                    formFields={Fields}
                    apiFunction={handleAddGarage}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewGarage;

